import { TransitionType } from '../domain';
const toDomain = backofficeTransition => {
  if (backofficeTransition.external) {
    return {
      type: TransitionType.EXTERNAL,
      targetUrl: backofficeTransition.external.targetUrl
    };
  }
  if (!backofficeTransition.internal) {
    throw new Error('Cannot map backoffice transition to domain: unknown transition type');
  }
  return {
    type: TransitionType.INTERNAL,
    targetFlowId: backofficeTransition.internal.targetFlowId,
    targetPageId: backofficeTransition.internal.targetPageId,
    targetSnapshotId: backofficeTransition.internal.targetSnapshotId
  };
};
export const transitionMapper = {
  toAPI: () => {
    throw new Error('not implemented: transitionMapper#toAPI');
  },
  toDomain
};
//# sourceMappingURL=transition.mapper.js.map